//Returns the whole object instead of a column to store

import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import InputBox from "../../Generic/InputBox";
import { get, getApi } from "../../config/api";
import Loader from "../../Generic/Loader";
import { randomId } from "../../util/util";

const Div = styled.div`
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: ${(props) => props.display};
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	border-radius: ${(props) => props.borderRadius};
	top: ${(props) => props.top};
	bottom: ${(props) => props.bottom};
	left: ${(props) => props.left};
	right: ${(props) => props.right};
	transition: 0.6s background ease-in-out;
	@media (max-width: 1000px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

Div.defaultProps = {
	display: "flex",
};

const Dropdown = styled.div`
	width: 100%;
	position: absolute;
	max-height: ${(props) => props.height};
	overflow-x: hidden;
	overflow-y: scroll;
	border: 1px solid #b3b3b3;
	background-color: #fff;
	z-index: 300;
`;

Dropdown.defaultProps = {
	height: "12rem",
};

const Item = styled.li`
	width: 100%;
	padding: 0.8rem 0.5rem;
	cursor: pointer;
	&:hover {
		background-color: #f1f1f1d7;
	}
	border-bottom: 1px solid #b3b3b36b;
	visibility: visible;
	list-style-type: none;
	background-color: #fff;
`;

const Text = styled.div`
	color: #090a3c;
	margin-bottom: 5px;
`;

export const SearchBarWithResults = (props) => {
	const { onChange, colsToStore, colToShow, search } = props;
	const dropdownRef = useRef(null);
	const [visible, setVisible] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	const [selectedItem, setSelectedItem] = useState(null);
	const [list, setList] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		//Add a event listener to the document to close the dropdown if user clicks outside dropdown
		document.addEventListener("mousedown", handleClick, false);
		return () => document.removeEventListener("mousedown", handleClick, false);
	}, []);

	const handleClick = (e) => {
		//If the user clicks outside the dropdown close the dropdown
		if (dropdownRef.current.contains(e.target)) {
			return;
		}
		setVisible(false);
	};

	const handleChange = (e) => {
		//Start search call when search query changes
		setSearchValue(e.target.value);
		handleSearch(e.target.value);
		if (!visible) {
			setVisible(true);
		}
	};

	const selectItem = (item) => {
		setSearchValue(item?.[colToShow]);
		onChange && onChange(item);
		setSelectedItem(item);
		setVisible(false);
	};

	//Search function to get the search results , uses endpoint prop
	const handleSearch = async (payload) => {
		setLoading(true);
		const { data, error } = await search(payload);
		setLoading(false);
		if(data) {
			setList(data);
		}
		if(error) {

		}
	}
	//Take colToStore from user for updating the value on change
	//Take colToShow to show the updated value

	return (
		<Div position="relative" display="" width="100%">
			<InputBox
				type="text"
				placeholder="Search Text"
				value={searchValue}
				onChange={handleChange}
				//Close Dropdown on blur and show it again when inputbox is focused
				onFocus={() => {
					setVisible(true);
				}}
				onBlur={() => {
					setVisible(false);
				}}
				padding="0.7rem"
				width="100%"
			/>
			<Dropdown
				ref={dropdownRef}
				className={visible ? "dropdown-open" : "dropdown-close"}
				height={props.height}>
				{/* Map the results recived from api , if result length is zero show text No result*/}
				{list.length && !loading
					? list.map((x) => (
							<Item key={x?._id} onClick={() => selectItem(x)}>
								<Text>{x?.[colToShow]}</Text>
							</Item>
					  ))
					: ""
				}
				{!list.length && !loading ? <Item>No result</Item> : ""}
				{loading ? <Loader /> : ""}
			</Dropdown>
		</Div>
	);
};
